<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <BaseModalFront
            :show="true"
            :title="$t('perfil.familia.create_modal_titulo')"
            :confirm-text="$t('perfil.familia.create_modal_confirmar')"
            :confirm-disabled="invalid || loading"
            :loading="loading"
            @close="emit('close')"
            @confirm="onCrear"
        >
            <div class="tw:flex tw:flex-col tw:gap-4">
                <p class="tw:text-sm tw:text-slate-600">
                    {{ $t('perfil.familia.create_modal_descripcion') }}
                </p>

                <InputText
                    :value="nombre"
                    :label="$t('perfil.familia.create_modal_nombre_label')"
                    name="nombre"
                    rules="required|max:255"
                    :disabled="loading"
                    @input="onInputNombre"
                />

                <!-- Error general -->
                <div
                    v-if="errorGeneral"
                    class="tw:rounded-lg tw:border tw:border-red-200 tw:bg-red-50 tw:p-3 tw:text-sm tw:text-red-700"
                >
                    {{ errorGeneral }}
                </div>
            </div>
        </BaseModalFront>
    </ValidationObserver>
</template>

<script setup>
    import { ref } from 'vue';
    import BaseModalFront from '@/modules/front/ui/BaseModalFront.vue';
    import InputText from '@/modules/front/ui/InputText.vue';
    import { t } from '@/utils/i18n-helper';

    const props = defineProps({
        abonadoId: {
            type: [Number, String],
            required: true,
        },
        crearFamilia: {
            type: Function,
            required: true,
        },
    });

    const emit = defineEmits(['close', 'created']);

    const observer = ref(null);
    const nombre = ref('');
    const loading = ref(false);
    const errorGeneral = ref(null);

    const onInputNombre = val => {
        nombre.value = val;
        observer.value?.validate();
    };

    const onCrear = async() => {
        const isValid = await observer.value?.validate();
        if (!isValid) return;

        loading.value = true;
        errorGeneral.value = null;
        try {
            await props.crearFamilia(
                props.abonadoId,
                nombre.value.trim()
            );
            emit('created');
            emit('close');
        } catch (err) {
            const status = err?.response?.status;
            const data = err?.response?.data;
            if (status === 422) {
                if (data?.errors) {
                    observer.value?.setErrors(data.errors);
                } else if (data?.error) {
                    errorGeneral.value = data.error;
                } else {
                    errorGeneral.value = t('perfil.familia.create_modal_error_crear', {}, 'No se pudo crear el grupo familiar. Verifica los datos.');
                }
            } else if (status === 403) {
                errorGeneral.value = data?.error ?? t('perfil.familia.create_modal_error_feature', {}, 'Funcionalidad no disponible para este teatro.');
            } else {
                errorGeneral.value = err?.message ?? t('perfil.familia.create_modal_error_generico', {}, 'Error al crear el grupo familiar.');
            }
        } finally {
            loading.value = false;
        }
    };
</script>
